import { render } from "./CatalogCardPreloaderComp.vue?vue&type=template&id=2705f77f&scoped=true&ts=true"
import script from "./CatalogCardPreloaderComp.vue?vue&type=script&lang=ts"
export * from "./CatalogCardPreloaderComp.vue?vue&type=script&lang=ts"

import "./CatalogCardPreloaderComp.vue?vue&type=style&index=0&id=2705f77f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2705f77f"]])

export default __exports__